<clr-alert [clrAlertType]="'danger'" [clrAlertAppLevel]="true" *ngIf="notificationType==='error'" (clrAlertClosedChange)="onClose()">
    <clr-alert-item>
        <span class="alert-text">
            {{notification}}
        </span>
    </clr-alert-item>
</clr-alert>
